import { PanoramaModel } from '@technology/web3d-plugin-panorama';
import { PlanarModel } from '@technology/web3d-plugin-planar';
import { TileMapModel } from '@technology/web3d-plugin-tilemap';
import type { Web3dModelTypes } from './web3d-model-types.types';

// e2e page.evaluate code cannot import modules, so instanceof checks need the classes on window.
// Not gated by env: e2e also runs against staging and production builds.
export function exposeWeb3dModelTypesForE2e(): void {
  const modelTypes: Web3dModelTypes = {
    /* eslint-disable @typescript-eslint/naming-convention -- names match the web3d class exports used by e2e instanceof checks */
    PanoramaModel,
    PlanarModel,
    TileMapModel,
    /* eslint-enable @typescript-eslint/naming-convention */
  };
  window.__web3dModelTypes = modelTypes;
}
